/**
 * Admin Panel — Restoran Yönetim
 *
 * Tenant-aware: tüm sayfalar AuthProvider altında, JWT'de tenant_id var.
 * RoleGate ile yetkisiz sayfa öğeleri gizlenir.
 */
import { Center, Loader } from "@mantine/core";
import { useAuth } from "../../shared/auth";
import { AppShell } from "./AppShell";
import { LoginPage } from "./pages/Login";

export function App() {
  const { isAuthenticated, isLoading } = useAuth();
  if (!isAuthenticated) return <LoginPage />;
  // Yetkiler ilk kez yüklenirken menüyü çizme — cookie auto-login sonrası
  // permission-bazlı menülerin boş `[]` ile eksik görünmesini önler.
  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  return <AppShell />;
}
